import React from 'react';
import { Navigation } from './Navigation';
import type { MarketingPage } from './Navigation';
import { BrandLogo } from './BrandLogo';

interface SiteHeaderProps {
  current: MarketingPage;
}

/**
 * Fixed top header for the plain (no-hero) pages. Its inner wrapper uses the
 * site-wide content container (--content-max / --content-pad), so the logo
 * lands on the LEFT body margin and the hamburger on the RIGHT body margin —
 * the same column the page content lives in. The bar itself is click-through
 * (pointer-events: none); only the logo and hamburger are interactive.
 *
 * Hero pages (home, product) do NOT use this — MarketingSite renders the
 * floating corner <Navigation> for those instead.
 */
export function SiteHeader({ current }: SiteHeaderProps) {
  return (
    <header className="site-header">
      <div className="site-header-inner">
        <BrandLogo />
        <Navigation current={current} />
      </div>
    </header>
  );
}
